import { createFileRoute, redirect } from "@tanstack/react-router";
import DiagnosticoHistorico from "@/components/admin/analytics/DiagnosticoHistorico";
import { resolveAdminRedirect } from "@/lib/adminRedirects";

// Sin ?historico=1 redirige a Analítica › Herramientas; con él muestra el archivo.
export const Route = createFileRoute("/admin/diagnostico")({
  beforeLoad: ({ location }) => {
    const target = resolveAdminRedirect(location.pathname, location.searchStr ?? "");
    if (target) throw redirect({ href: target, replace: true });
  },
  component: DiagnosticoHistorico,
});
